import Cookies from 'js-cookie';
var TokenKey = 'emis_yun_token';
var UserIdKey = 'emis_yun_userid';
var SchoolIdKey = 'emis_yun_schoolid';
var PhoneKey = 'emis_yun_phone';
var AccountType = 'emis_yun_account_type';
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function setAccountType(accounttype) {
  return Cookies.set(AccountType, accounttype);
}
export function getAccountType() {
  return Cookies.get(AccountType);
}
export function removeAccountType() {
  return Cookies.remove(AccountType);
}
export function getPhone() {
  return Cookies.get(PhoneKey);
}
export function setPhone(phone) {
  return Cookies.set(PhoneKey, phone);
}
export function removePhone() {
  return Cookies.remove(PhoneKey);
}
export function setUserId(userid) {
  return Cookies.set(UserIdKey, userid);
}
export function getUserId() {
  return Cookies.get(UserIdKey);
}
export function removeUserId() {
  return Cookies.remove(UserIdKey);
}
export function getSchoolId() {
  return Cookies.get(SchoolIdKey);
}
export function setSchoolId(sid) {
  return Cookies.set(SchoolIdKey, sid);
}
export function removeSchoolId() {
  return Cookies.remove(SchoolIdKey);
}